import { jsx as _jsx } from "react/jsx-runtime";
import _defineProperty from "/var/www/kanoon-stage/frontend/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import __i18nConfig from '@next-translate-root/i18n';
import __appWithI18n from 'next-translate/appWithI18n';
import '../assets/css/globals.css';
import "../components/navbar/Navbar.css";
import 'bootstrap/dist/css/bootstrap.min.css';
import '../components/sidebarPro/styles/global.scss';
import ThemeContext, { themes } from "../components/sidebarPro/services/context/themeContext";
import { Context } from "../context/UserData";
import React, { useState } from 'react';
import 'react-vis/dist/style.css';
import LanguageContext, { locales } from "../context/LanguageContext";

function MyApp(_ref) {
  var Component = _ref.Component,
      pageProps = _ref.pageProps;

  var _useState = useState(locales),
      language = _useState[0],
      setLanguage = _useState[1];

  var toggleLanguage = function toggleLanguage() {
    setLanguage(_objectSpread(_objectSpread({}, language), {}, {
      isEnglish: !language.isEnglish
    }));
  };

  return /*#__PURE__*/_jsx(LanguageContext.Provider, {
    value: {
      language: language,
      toggleLanguage: toggleLanguage
    },
    children: /*#__PURE__*/_jsx(Component, _objectSpread({}, pageProps))
  });
}

var __Page_Next_Translate__ = MyApp;
export default __appWithI18n(__Page_Next_Translate__, _objectSpread(_objectSpread({}, __i18nConfig), {}, {
  isLoader: true,
  skipInitialProps: true,
  loadLocaleFrom: function loadLocaleFrom(l, n) {
    return import("@next-translate-root/locales/".concat(l, "/").concat(n)).then(function (m) {
      return m["default"];
    });
  }
}));